import { render, staticRenderFns } from "./StoreFacet_Item.vue?vue&type=template&id=639663e6&"
import script from "./StoreFacet_Item.vue?vue&type=script&lang=js&"
export * from "./StoreFacet_Item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports